/* eslint-disable no-redeclare */
import { z } from 'zod';

export const Tags = z.record(
  z.string(),
  z.union([z.string(), z.number(), z.boolean()]),
);
export type Tags = z.infer<typeof Tags>;

export const CountMetricName = z.enum([
  'connect-me',
  'page-view',
  'click',
  'abandonment-modal',
  'ad-impression',
  'skip-pii',
  'jornaya-result',
  'consent-source',
  'consent-script-load',
  'consent-tokens-at-pii',
]);

export type CountMetricName = z.infer<typeof CountMetricName>;

const CountMetricBase = z.object({
  name: CountMetricName,
  tags: Tags,
});

export const CountMetric = z.discriminatedUnion('name', [CountMetricBase]);

export type CountMetric = z.infer<typeof CountMetric>;
